import Roles from '@/shared/utils/roles'
import { derivaConsulta as deriva } from '@/shared/utils/consultaReadonly'

// As roles de ESCRITA da Despesa Viagem -- as mesmas que o `expectedRoles` das rotas de detalhe
// listava antes de as 2 de consulta entrarem.
//
// Existe porque as 2 telas de detalhe (`DetailsPaidLots` e `CollaboratorTableTravelExpenseEmploye`)
// sao ROTA SEPARADA da tela de consulta: a prop `isConsulta` nao chega la, e o read-only vinha so
// de `consulta=1` na query -- que o usuario reescreve na barra do navegador. Com a rota liberada
// pra persona de consulta, entrar sem o parametro devolvia PEDIDO/GERAR -> `GerarPedido`, escrita
// sem `[Authorize]` no backend. Entao o read-only vale tambem pelo avesso: sem NENHUMA destas,
// a tela e leitura.
export const ROLES_ESCRITA_VIAGEM = [
  Roles.RW_ZPAG_VIAGEM,
  Roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL,
  Roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL
]

export const derivaConsulta = (query, hasRole) => deriva(query, hasRole, ROLES_ESCRITA_VIAGEM)



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpensezpag/rolesEscritaViagem.js